import React from "react";
import { Modal } from "react-bootstrap";

export default ({ apiErrorInfo, modalHideHandler }) => {
  return (
    <Modal
      show={apiErrorInfo.isApiEndPointFailed}
      centered
      backdrop="static"
      size="sm"
      onHide={modalHideHandler}
    >
      <Modal.Header closeButton>
        <Modal.Title>{apiErrorInfo.title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="overflow-auto">
        <p>{apiErrorInfo.message}</p>
      </Modal.Body>
    </Modal>
  );
};
